import { type Styles } from '@chakra-ui/theme-tools';
import { $color } from '@/utils/cssVarUtils';

export const styles: Styles = {
  global: {
    body: {
      fontSize: '1rem',
      bg: $color('bg-normal'),
      color: $color('text-normal'),
      transitionProperty: "background-color",
      transitionDuration: "normal",
      lineHeight: "base",
      margin: 0,
    },
    "*::placeholder": {
      color: $color('text-placeholder'),
    },
    "*, *::before, &::after": {
      borderColor: $color('scene-border'),
      wordWrap: "break-word",
    },
    mark: {
      // bg: $color('scene-primary-normal')
    }
  }
}